import { ZfBox } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { formatAmount } from '../../utils/renderUtils';

interface IProps {
    label: string;
    amount: number;
    currency?: string;
}

export const WealthOverviewTotalDataItem: FunctionComponent<IProps> = ({ label, amount, currency }) => (
    <ZfBox className="wealth-overview__total-item">
        <div className="wealth-overview__total-item__label text-web-body-regular-sm">{label}</div>
        <h4>{`${currency ?? ''} ${formatAmount(amount, false, '', true)}`}</h4>
    </ZfBox>
);
